import CallForwardCard from './CallForwardCard.component';

export * from './CallForwardCard.component';
export default CallForwardCard;